export const initialState = {
    translations: {
        data: {},
        isFetching: false,
        error: ''
    }
};
